module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no5-1e56596dcae15d5a9315216282410d59.png";